import create from 'zustand';
import { CreateQueryFreezeState } from './interfaces/CreateQueryState';
import { createQueryFreezeSlice } from './slices/CreateQueryFreezeSlice/CreateQueryFreezeSlice';

export const useCreateQueryFreezeStore = create<CreateQueryFreezeState>((set) => ({
  ...createQueryFreezeSlice(set)
}));
